import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    const getPlayer = (playerObj) => {
        let { player } = playerObj;
        let loggedIn = player ? true : false;

        if (loggedIn) {
            return {
                loggedIn: loggedIn,
                player: {
                    registrar_id: player.registrar_id,
                    name: player.firstname + ' ' + player.lastname,
                    email: player.email,
                    first_name: player.firstname,
                    last_name: player.lastname,
                    email_confirm: player.email,
                    zip: player.address ? player.address.zip : '',
                    phone1: player.phone,
                },
            };
        } else {
            return {
                loggedIn: false,
            };
        }
    };

    return async (payload) => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);

        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            if (!spatFromCookie && jwtFromCookie) {
                let result = await apiClient(config).apiMethod({
                    method: 'getSpatWithJwt',
                    headers: {
                        'X-Auth-Token': jwtFromCookie,
                    },
                });

                return getPlayer(result);
            } else if (spatFromCookie) {
                return getPlayer(JSON.parse(spatFromCookie));
            } else {
                return {
                    loggedIn: false,
                };
            }
        } else {
            return {
                loggedIn: false,
            };
        }
    };
};
